import { Component, OnInit } from '@angular/core'
import { TranslocoService } from '@ngneat/transloco'

@Component({
  selector: 'app-transloco-root',
  template: '<ng-content></ng-content>',
})
export class TranslocoRootComponent implements OnInit {
  constructor(private translocoService: TranslocoService) {}

  ngOnInit() {
    // Set default language to Czech
    this.translocoService.setDefaultLang('cs')
    this.translocoService.setActiveLang('cs')
  }
}